(function () {
  'use strict';

  /* @ngdoc object
   * @name camadaValor
   * @description
   *
   */
  angular
    .module('camadaValor', [
      'ui.router',
      'restangular',
      'v3gAuthenticatorModule'
    ]);
}());
